import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import { IGetRecommendationsNearResponse } from 'shared/common/repositories/newbuilding-search/entities/get_recommendations_near_newbuilding/GetRecommendationsNearResponse';
import { getGeoObject } from 'shared/mf-infrastructure/utils/getGeoObject';

import { transformSimilarNewbuildingsToInfrastructureItems } from './transformSimilarNewbuildingsToInfrastructureItems';

export const transformSimilarNewbuildingsToGeoObjects = (result: IGetRecommendationsNearResponse): IGeoObject[] => {
  return transformSimilarNewbuildingsToInfrastructureItems(result).map(getGeoObject);
};
